export * from './workouts.model';



// WEBPACK FOOTER //
// ./src/app/pages/workouts/store/index.ts